import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const freeDayCard: ThemeUICSSObject = {
  '&.fileCard': {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    border: '1px solid',
    borderColor: 'palette.gray.800',
    height: '50px',
    // borderRadius: 'default',
    borderRadius: '7px',
    boxShadow: '0px 1px 1px #c7c7c7',
    background: 'palette.background.paper',
    cursor: 'pointer',
    '.fileCard__content': {
      display: 'flex',
      alignItems: 'center',
      p: 3,
      gap: 3,
      width: '100%',
    },

    button: {
      boxShadow: 'none',
    },
  },

  '&.selected': (theme) => {
    return {
      backgroundColor: theme.palette.getColor('transparent', 'selected'),
    };
  },
  '&.fileList__modal': {
    // pr: 7,
  },

  '.file__icon': {
    flexShrink: 0,
  },

  '.fileCard__name': {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  '.fileCard__additionalButtons': {
    flexShrink: 0,
    display: 'flex',
    height: '100%',
    ml: 3,
  },
  '.fileCard__additionalButtons:hover': {
    color: 'palette.text.primary',
  },
  '.fileCard__delete, .fileCard__additionalButton': {
    width: 'auto',
    height: '100%',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    m: 0,
    flexShrink: 0,
    px: 3,
    color: 'palette.text.primary',
    backgroundColor: 'palette.background.paper',
    svg: {
      width: '20px',
      height: '20px',
    },
  },
};

export default freeDayCard;
